import React from "react";
import Layout from "./../components/Layout/Layout";

const About = () => {
  return (
    <Layout title={"About Us - AnyTrade"}>
      <div className="row contactus ">
        <div className="col-md-6 ">
          <img
            src="/images/about.jpeg"
            alt="contactus"
            style={{ width: "100%" }}
          />
        </div>
        <div className="col-md-4">
          <p className="text-justify fw-3 fs-6 mt-2">
            Hello Guys,
            <br />
            Welcome to Online Shoping Store <abbr className="text-success fw-bolder"> AnyTrade</abbr>
            <br />
            Design and Developed by Team <abbr className="text-primary fw-bolder"> TradeBug</abbr>
            <br />
            <h5 className="text-dark my-3 fw-bold "> Our Team: </h5>
            <p className="text-dark mx-4  ">
              <li>Aniket Zanje</li>
              <li>Abhay shelke</li>
              <li>Vishakha sarkale</li>
              <li> Sakshi narvate</li>
            </p>

            <br />

          </p>
        </div>
      </div>
    </Layout>
  );
};

export default About;
<p className="text-center fw-3 fw-bold font-bold my-2">
  copyright &copy;
  <abbr className="text-success"> AnyTrade</abbr>
</p>